import "../../assets/scss/_commomAdminPages.scss";

const renderHeader = (params) => {
  return <div className="header-datagrid" style={{ whiteSpace: "normal", overflowWrap: "break-word"}}>{params.colDef.headerName}</div>;
};

export default renderHeader;
